import { useQuery, useQueryClient, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { useAuthToken } from "capitalrx-shell";

import { ClaimLogs } from "@/types/appTypes/claims";
import { getClaimLogs } from "@/App/api/claim";
import { useFailureHandler } from "../../hooks";

export const useAPIGetQuery = <Request, Response>(
  url: string,
  apiCall: (authToken: string, request: Request) => Promise<Response>,
  request: Request,
  options?: Omit<UseQueryOptions<Response, AxiosError>, "queryKey">,
): UseQueryResult<Response, AxiosError> => {
  const [authToken] = useAuthToken();

  return useQuery<Response, AxiosError>({
    queryKey: [url, request],
    queryFn: () => apiCall(authToken, request),
    ...options,
  });
};

export const useGetClaimLogs = () => {
  const failureHandler = useFailureHandler();

  try {
    const queryClient = useQueryClient();
    const [authToken] = useAuthToken();

    return (payload: { id: number, log_key?: string }) => {
      const result: Promise<ClaimLogs> = queryClient.fetchQuery({
        queryKey: ["/claim/get_logs", payload.id, payload.log_key],
        queryFn: () => getClaimLogs(payload, authToken),
      });

      result.then((data: ClaimLogs) => {
        window.location.href = data.url;
      });
    };
  } catch (error: unknown) {
    failureHandler(error as AxiosError);
  }
};
